import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SchoolService } from '../service/school.service';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { FormControl } from '@angular/forms';
import { PageNotFoundComponent} from 'src/app/page-not-found/page-not-found.component'
import { ChangeDetectionStrategy, HostListener } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { School } from '../admin-interfaces';
import { Table } from 'primeng/components/table/table';
import { ReportMeritService } from '../service/report-merit.service';
import { IssoUtilService } from 'src/app/services/isso-util.service';
import { AdminFeaturesService } from '../service/admin-features.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin-school',
  templateUrl: './admin-school.component.html',
  styleUrls: ['./admin-school.component.css'],
  providers: [MessageService,ConfirmationService]
})
export class AdminSchoolComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  schoolForm: FormGroup;
  showspinner: boolean;
  options: SelectItem[];
  zoneOptions: SelectItem[];
  /** Zone list for the FILTER - 'All zones' first, no empty option. */
  zoneFilterOptions: SelectItem[] = [];
  editForm: FormGroup;
  public errorAlert:boolean=false;
  errormessage: boolean;
  submitted = false;
  display: boolean = false;
   // options: SelectItem[];
  schoolArray =[];
  
  control: FormControl;
  schoolServiceDATA:any;
  school: School;
  error: string;
  datasource: any;
  totalRecords: number;
  cols: any[];
  placeholderText = "Select Option"
  actions: string;
  loading: boolean;
  pageSizeOptions = [10, 25, 50, {showAll: 'All'}]
  disable = false;
  cities1: SelectItem[];
  schoolData: School[];
  showRegisterdSchoolData;
  subViewTitle: string;
  schoolType: string;
  approvedData: string;
  /**
   * Schools tab filter: 'approved' (default) | 'pending' | 'all'.
   *
   * The directory is the list of schools ISSO has approved, so an application
   * still waiting on a decision does not belong in it - it belongs in the
   * New registrations tab. Widen the filter to see those here.
   */
  approvalFilter = 'approved';
  approvalFilterOptions: SelectItem[] = [
    { label: 'All schools', value: 'all' },
    { label: 'Approved only', value: 'approved' },
    { label: 'Awaiting approval', value: 'pending' },
  ];
  volunteerData:string;
  zoneData:string;
  registeredSchoolZone:string;
  schoolServiceData:any;
  registerdSchoolData:any;
  expandedRows: number[];
  rowGroupMetadata = {};
  table: Table;
  sortKey: string;
  sortField: string;
  sortOrder: number;
  selectedSchool: School;
  selectedZoneVal:string;
  carDatavalue:any;
  carId:number
  editingSchoolId: number = 0;
  startingMirror = false;
  /** Bound to the one search box in the tab bar; applied to whichever view is open. */
  tabSearch = '';
  selectedDoc: File = null;
  /** Registration id the staged file belongs to - one grid, one shared field. */
  selectedDocFor: any = null;
  uploadingDoc = false;
  /** Last upload failure, shown on the card - a toast scrolls away. */
  docError = '';
  editingSchoolName = '';
  editingSavedEmail = '';   // the address on record, to spot unsaved edits
  sendingResetLink = false;
  /** Direct password reset modal (admin sets the password itself). */
  resetPwOpen = false;
  resetPwNew = '';
  resetPwConfirm = '';
  resetPwBusy = false;
  resetPwError = '';
  resetPwShow = false;
  displayDialog: boolean;
  confirmDropDatabaseDialogVisible = false;
  testVar: string;
  isPcUser: boolean;
  testArray: { id: number; text: string; }[];
  registeredSchoolFlag: boolean;
  setPassword: string;
  showEmailErrorMessage: boolean;
  emailOfSchool: any;
  verifyEmailForSchool: any;
  schoolEdit: boolean;
  totalNonAffilatedSchoool: number;
  totalSchoolCount: number;


  constructor(
    private confirmation: ConfirmationService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private router: Router,
    private schoolService: SchoolService,
    private meritService: ReportMeritService,
    private issoUtilService: IssoUtilService,
    private adminFeatures: AdminFeaturesService,
  ) {
    setTimeout(()=>{this.disable = true}, 5000)
   }

  // ── ISSO undertaking ──────────────────────────────────────────────────────
  undertakingDialog = false;
  undertakingAvailable = false;
  undertakingHref = '';
  undertakingFile: File | null = null;
  undertakingBusy = false;
  undertakingError = '';

  loadUndertaking() {
    this.undertakingHref = this.adminFeatures.undertakingUrl();
    this.adminFeatures.undertakingStatus()
      .subscribe((r: any) => { this.undertakingAvailable = !!r.available; }, () => {});
  }

  onUndertakingPick(e: any) {
    const f: File = e.target.files && e.target.files[0];
    this.undertakingError = '';
    if (f && !/\.pdf$/i.test(f.name)) {
      this.undertakingError = 'The undertaking must be a PDF';
      this.undertakingFile = null;
      return;
    }
    this.undertakingFile = f || null;
  }

  uploadUndertaking() {
    if (!this.undertakingFile || this.undertakingBusy) return;
    this.undertakingBusy = true;
    this.undertakingError = '';
    this.adminFeatures.uploadUndertaking(this.undertakingFile).subscribe(
      () => {
        this.undertakingBusy = false;
        this.undertakingDialog = false;
        this.undertakingFile = null;
        this.undertakingAvailable = true;
        this.messageService.add({ key: 'custom', severity: 'success', summary: 'ISSO undertaking updated' });
      },
      (e: any) => {
        this.undertakingBusy = false;
        this.undertakingError = (e && e.error && e.error.error) || 'Upload failed';
      },
    );
  }

ngOnInit() {
    this.loadUndertaking();
    this.initialForm();
    this.loading = true;
    this.selectedZoneVal = 'noZone';
    setTimeout(()=> {this.placeholderText = 'It has changed'}, 5000)
    this.getSchoolData()
}
registeredSchool() {
  this.registeredSchoolFlag = true;
  this.schoolService.getRegisterSchoolList().pipe(takeUntil(this.destroy$)).subscribe(response => {
    if(response!=="") {
      this.registerdSchoolData =response;
      this.showRegisterdSchoolData = this.registerdSchoolData;
      // Re-point the detail pane: after an upload or an approval this list is
      // refetched, and the old object would leave the pane showing stale data.
      this.syncRegSelection();
    } else {
      this.registerdSchoolData = [];
      this.showRegisterdSchoolData = [];
      this.selectedReg = null;
    }

 } ,
 error => {
   //this.errorAlert =true;
  });
}
loadData(event) {
}
/**
 * Zone filter.
 *
 * This read event.value into a local and then did nothing with it - two empty
 * branches - so selectedZoneVal stayed on the 'noZone' set at init and the
 * dropdown had never filtered anything. The server already handles the zone
 * (case-insensitively); it just was not being asked.
 */
filterSchoolList(event) {
  this.selectedZoneVal = (event && event.value) ? event.value : 'noZone';
  this.getSchoolData();
}
  /** The affiliation and volunteer dropdowns speak 'Yes' / 'No', not booleans. */
  yesNo(v: any): string {
    return (v === true || v === 'true' || v === 'Yes' || v === 'yes' || v === 1 || v === '1') ? 'Yes' : 'No';
  }

/**
 * Mirror Mode - open this school's portal signed in AS them.
 *
 * Confirmed first, and the wording says plainly what it does: the admin is about
 * to act inside a real school's records, and anything changed lands on the
 * school's account rather than the admin's.
 */
/** Mirror Mode from the Registered School Data queue, keyed on the application. */
/** Tabs. Each one loads its own view, so the data cannot go stale behind the other. */
showSchoolsTab() {
  this.registeredSchoolFlag = false;
  this.tabSearch = '';
  this.getSchoolData();
}

showRegisteredTab() {
  this.tabSearch = '';
  this.registeredSchool();
}

/**
 * One search box for both tabs.
 *
 * The dataviews are separate components with their own filters, and the box now
 * lives outside both, so the filtering is done here against the source list
 * rather than through `dv.filter()`.
 */
applyTabSearch(term: string) {
  const q = (term || '').trim().toLowerCase();
  // Registrations has its own search at the top of its list now, and filtering
  // showRegisterdSchoolData from here as well would mean two boxes fighting
  // over the same array.
  if (this.registeredSchoolFlag) { return; }
  this.schoolData = !q
    ? this.schoolServiceData
    : (this.schoolServiceData || []).filter((r: any) =>
        ((r.name || '') + ' ' + (r.address || '') + ' ' + (r.email || '')).toLowerCase().indexOf(q) > -1);
}

/** "3.20 MB" / "812 KB" */
docSize(bytes: number): string {
  if (bytes == null) { return ''; }
  return bytes >= 1024 * 1024
    ? (bytes / (1024 * 1024)).toFixed(2) + ' MB'
    : Math.round(bytes / 1024) + ' KB';
}

/** Whatever the server actually said, verbatim where there is anything to quote. */
uploadErrorText(err: any, fileName: string, size: number): string {
  const status = err && err.status;
  const body = err && err.error;
  let said = '';
  if (typeof body === 'string') {
    // nginx answers 413 with an HTML page - strip it back to the heading.
    const m = body.match(/<h1[^>]*>([^<]+)<\/h1>/i) || body.match(/<title[^>]*>([^<]+)<\/title>/i);
    said = (m ? m[1] : body).trim().slice(0, 300);
  } else if (body && (body.message || body.error)) {
    said = String(body.message || body.error);
  } else if (err && err.message) {
    said = String(err.message);
  }
  const where = status === 413
    ? fileName + ' is ' + this.docSize(size) + ' - larger than the server accepts.'
    : fileName + ' (' + this.docSize(size) + ') failed to upload.';
  const code = status ? 'HTTP ' + status : 'no response';
  return where + ' [' + code + (said ? ': ' + said : '') + ']';
}

/** Stage the chosen PDF. Sending it is part of approving - see submitApprove. */
onDocSelected(event: any, row?: any, input?: any) {
  void input;
  const file = event && event.target && event.target.files && event.target.files[0];
  this.selectedDoc = file || null;
  this.selectedDocFor = file && row ? row.schoolId : null;
  this.docError = '';
}

/**
 * Upload the signed undertaking on a school's behalf.
 *
 * Approval is gated on the document being present, so a school that never
 * uploads one blocks itself indefinitely. This posts to the same endpoint and
 * storage the school's own upload uses, so the resulting record is identical.
 */
uploadRegistrationDoc(row: any, input: any, onDone?: () => void) {
  if (!this.selectedDoc || !row || !row.schoolId) { return; }
  if (this.selectedDocFor !== row.schoolId) { return; }
  if (!/\.pdf$/i.test(this.selectedDoc.name)) {
    this.messageService.add({ key: 'custom', severity: 'error', summary: 'Upload', detail: 'The undertaking must be a PDF.' });
    return;
  }
  // Caught here where the size is still known: nginx answers an oversized body
  // with an HTML error page, not JSON.
  const MAX_MB = 2;
  if (this.selectedDoc.size > MAX_MB * 1024 * 1024) {
    this.docError = this.selectedDoc.name + ' is ' + this.docSize(this.selectedDoc.size)
      + '. The undertaking must be under ' + MAX_MB + ' MB.';
    this.messageService.add({
      key: 'custom', severity: 'error', summary: 'Upload', life: 12000, detail: this.docError,
    });
    return;
  }
  this.uploadingDoc = true;
  this.docError = '';
  const docName = this.selectedDoc.name;
  const docBytes = this.selectedDoc.size;
  const formData = new FormData();
  // `schoolId` on this grid is the APPLICATION id, as the rest of this screen uses.
  formData.append('schoolId', row.schoolId);
  formData.append('profile', this.selectedDoc, this.selectedDoc.name);

  this.schoolService.uploadDoc(formData).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.uploadingDoc = false;
      if (res && res.status === 'error') {
        this.docError = docName + ' (' + this.docSize(docBytes) + '): ' + (res.message || 'Upload failed.');
        this.messageService.add({
          key: 'custom', severity: 'error', summary: 'Upload', life: 12000, detail: this.docError,
        });
        return;
      }
      this.selectedDoc = null;
      this.selectedDocFor = null;
      if (input) { input.value = ''; }
      this.messageService.add({
        key: 'custom', severity: 'success', summary: 'Upload',
        detail: 'Undertaking uploaded. This school can now be approved.',
      });
      // Reload so the card swaps to "View signed undertaking" and the Approve
      // button appears - both are driven by `document` being non-empty. The row
      // object is updated in place too, so the open card changes immediately
      // rather than waiting for the round trip.
      row.document = 'pending-refresh';
      this.registeredSchool();
      // Approving straight after an upload: the row now carries a document, so
      // the caller can finish without a second press.
      if (onDone) { onDone(); }
    },
    (err: any) => {
      this.uploadingDoc = false;
      this.docError = this.uploadErrorText(err, docName, docBytes);
      this.messageService.add({
        key: 'custom', severity: 'error', summary: 'Upload', life: 15000, detail: this.docError,
      });
      console.error('uploadDoc failed', err);
    },
  );
}

confirmMirrorRegistration(row: any) {
  const name = (row && row.name) || 'this school';
  const pending = !row || String(row.approve) !== '1';
  this.confirmation.confirm({
    key: 'confirm-mirror',
    message:
      `You are about to open the portal as <strong>${name}</strong>.<br><br>` +
      (pending
        ? `This school is <strong>not approved yet</strong>, so you will see the ` +
          `"awaiting ISSO approval" screen - exactly what they see when they sign in.<br><br>`
        : `You will see exactly what the school sees, and <strong>anything you change is saved ` +
          `to their records</strong>.<br><br>`) +
      `Every change you make is logged against your admin account. The session lasts 30 minutes ` +
      `and opens in a new tab.`,
    accept: () => { this.openMirrorRegistration(row); },
  });
}

openMirrorRegistration(row: any) {
  if (!row || !row.schoolId) { return; }
  this.startingMirror = true;
  // Opened before the request returns, or the browser treats it as a popup.
  const tab = window.open('', '_blank');
  // `schoolId` on this grid is the APPLICATION id, as changeApprovedStatus uses.
  this.schoolService.startMirrorModeForRegistration(row.schoolId).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.startingMirror = false;
      // The SERVER says where the portal is: this bundle is deployed to several
      // environments, and a compiled-in host sent staging admins to production.
      const base = (res && res.mirrorUrl) || (environment.portalUrl + '/school/mirror');
      const url = base + '?ticket=' + encodeURIComponent(res.ticket);
      if (tab) { tab.location.href = url; } else { window.open(url, '_blank'); }
    },
    (err: any) => {
      this.startingMirror = false;
      if (tab) { tab.close(); }
      this.messageService.add({
        key: 'custom', severity: 'error', summary: 'Mirror Mode',
        detail: (err && err.error && err.error.error) || 'Could not open Mirror Mode for this school.',
      });
    },
  );
}

confirmMirrorMode() {
  const ctrl = this.schoolForm.get('schoolname');
  const name = (ctrl && ctrl.value) || 'this school';
  this.confirmation.confirm({
    key: 'confirm-mirror',
    message:
      `You are about to open the portal as <strong>${name}</strong>.<br><br>` +
      `You will see exactly what the school sees, and <strong>anything you change is saved to ` +
      `their records</strong> - enrolments, students and payments included.<br><br>` +
      `Every change you make is logged against your admin account. The session lasts 30 minutes ` +
      `and opens in a new tab.`,
    accept: () => { this.openMirrorMode(); },
  });
}

/**
 * Mirror Mode from a school card.
 *
 * The edit form's version reads editingSchoolId, so mirroring used to mean
 * opening the editor first. The card carries the school, so it can ask directly.
 */
confirmMirrorForSchool(school: any) {
  const name = (school && school.name) || 'this school';
  this.confirmation.confirm({
    key: 'confirm-mirror',
    message:
      `You are about to open the portal as <strong>${name}</strong>.<br><br>` +
      `You will see exactly what the school sees, and <strong>anything you change is saved to ` +
      `their records</strong> - enrolments, students and payments included.<br><br>` +
      `Every change you make is logged against your admin account. The session lasts 30 minutes ` +
      `and opens in a new tab.`,
    accept: () => { this.openMirrorModeFor(school && school.id); },
  });
}

openMirrorModeFor(schoolId: number) {
  if (!schoolId) { return; }
  this.startingMirror = true;
  const tab = window.open('', '_blank');
  this.schoolService.startMirrorMode(schoolId).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.startingMirror = false;
      const base = (res && res.mirrorUrl) || (environment.portalUrl + '/school/mirror');
      const url = base + '?ticket=' + encodeURIComponent(res.ticket);
      if (tab) { tab.location.href = url; } else { window.open(url, '_blank'); }
    },
    (err: any) => {
      this.startingMirror = false;
      if (tab) { tab.close(); }
      this.messageService.add({
        key: 'custom', severity: 'error', summary: 'Mirror Mode',
        detail: (err && err.error && err.error.error) || 'Could not open Mirror Mode for this school.',
      });
    },
  );
}

/** Which school's mirror button is busy - without this every card spins at once. */
mirroringId = 0;

/** Zone / approval live behind a filter button now, not in the toolbar. */
filtersOpen = false;
toggleFilters() { this.filtersOpen = !this.filtersOpen; this.moreOpen = false; }

/**
 * Export and the undertaking PDF sit behind "More options".
 *
 * Three equal-weight buttons made the one thing an admin comes here to do -
 * add a school - compete with two it does occasionally.
 */
moreOpen = false;
toggleMore() { this.moreOpen = !this.moreOpen; this.filtersOpen = false; }
closeMenus() { this.moreOpen = false; this.filtersOpen = false; }
/** Shown on the filter button so a narrowed list is never a surprise. */
activeFilterCount(): number {
  let n = (this.selectedZoneVal && this.selectedZoneVal !== 'noZone') ? 1 : 0;
  if (this.approvalFilter !== 'approved') n++;
  return n;
}

/** Re-reads the tab when the approval filter changes. */
filterByApproval() {
  this.getSchoolData();
}

/** True for a school that is in the list but has not been approved yet. */
isPending(school: any): boolean {
  return !(school && school.isApproved);
}

/* ── Registrations: master / detail ──────────────────────────────────────
   The queue was a grid of cards, each carrying the whole application - zone
   dropdown, upload control, approve button, mirror - so twenty applications
   meant twenty copies of every control and a lot of scrolling to compare two
   schools. A list on the left, one application on the right. */

/** The application open in the right-hand pane. */
selectedReg: any = null;
/** Left-pane search. Separate from the Schools tab's box, which is its own list. */
regSearch = '';

/** The list actually rendered on the left, after the search. */
get regList(): any[] {
  const rows: any[] = this.showRegisterdSchoolData || [];
  const q = (this.regSearch || '').trim().toLowerCase();
  if (!q) { return rows; }
  return rows.filter((r: any) =>
    ((r.name || '') + ' ' + (r.email || '') + ' ' + (r.address || '') + ' ' + (r.mobile || ''))
      .toLowerCase().indexOf(q) > -1);
}

/* The queue runs to a few hundred applications; one scrolling column meant
   dragging through all of them to reach the older ones. */
regPage = 0;
regPageSize = 10;

get regTotal(): number { return this.regList.length; }
get regTotalPages(): number { return Math.max(1, Math.ceil(this.regTotal / this.regPageSize)); }

/** The slice on screen. Clamps the page rather than writing to it - a setter
    firing during change detection is what causes ExpressionChanged errors. */
get regPaged(): any[] {
  const page = Math.min(Math.max(this.regPage, 0), this.regTotalPages - 1);
  const start = page * this.regPageSize;
  return this.regList.slice(start, start + this.regPageSize);
}

/** 1-based bounds for the "x-y of n" line. */
get regFrom(): number { return this.regTotal ? Math.min(this.regPage, this.regTotalPages - 1) * this.regPageSize + 1 : 0; }
get regTo(): number { return Math.min(this.regFrom + this.regPageSize - 1, this.regTotal); }

goRegPage(n: number) {
  const next = Math.min(Math.max(n, 0), this.regTotalPages - 1);
  if (next === this.regPage) { return; }
  this.regPage = next;
  // Open the first application on the page just turned to, so the detail pane
  // always matches what the list is showing.
  const rows = this.regPaged;
  if (rows.length) { this.selectReg(rows[0]); }
}

selectReg(row: any) {
  this.selectedReg = row;
  this.docError = '';
  // Staged-but-unsent file belongs to the row it was picked for.
  if (!row || this.selectedDocFor !== row.schoolId) { this.selectedDoc = null; this.selectedDocFor = null; }
}

/** Open the first application so the pane is never empty on arrival. */
syncRegSelection() {
  const all = this.regList;
  if (!all.length) { this.selectedReg = null; return; }
  if (this.regPage > this.regTotalPages - 1) { this.regPage = this.regTotalPages - 1; }
  const keep = this.selectedReg
    && all.filter((r: any) => r.schoolId === this.selectedReg.schoolId)[0];
  if (keep) {
    // Follow the row to whichever page it now sits on, so the highlighted item
    // is actually on screen.
    const idx = all.indexOf(keep);
    this.regPage = Math.floor(idx / this.regPageSize);
    this.selectReg(keep);
    this.repointApprove(all);
    return;
  }
  const rows = this.regPaged;
  this.selectReg(rows.length ? rows[0] : all[0]);
  this.repointApprove(all);
}

/**
 * Re-point the open dialog at the refreshed row.
 *
 * `approveFor` is deliberately its own reference so the dialog cannot be
 * swapped by clicking the list behind it - but a refetch replaces every row
 * object, so after uploading an undertaking the dialog was still holding the
 * pre-upload copy and its Approve button stayed disabled.
 */
private repointApprove(all: any[]) {
  if (!this.approveOpen || !this.approveFor) { return; }
  const fresh = all.filter((r: any) => r.schoolId === this.approveFor.schoolId)[0];
  if (fresh) { this.approveFor = fresh; }
}

onRegSearch(term: string) {
  this.regSearch = term || '';
  // A narrowed list almost never has the same page count.
  this.regPage = 0;
  this.syncRegSelection();
}

/** Has the signed undertaking been received? The field is '' until it has. */
regHasDoc(row: any): boolean {
  return !!row && !!row.document && String(row.document).trim() !== '';
}

regApproved(row: any): boolean {
  return !!row && String(row.approve) === '1';
}

/* ── Approve dialog ──────────────────────────────────────────────────────
   Approval needs a signed undertaking and a zone. Those two controls used to
   sit in the detail pane, on every application, whether or not anyone was
   approving anything - so the pane carried an upload box and a dropdown that
   were irrelevant most of the time. They are asked for at the moment of
   approving instead, in one dialog, with the confirmation. */
approveOpen = false;
/** The application being approved - held so the dialog is not re-reading a
    selection the admin may change behind it. */
approveFor: any = null;

openApprove(row: any) {
  if (!row) { return; }
  this.approveFor = row;
  this.docError = '';
  this.approveOpen = true;
}

closeApprove() {
  this.approveOpen = false;
  this.approveFor = null;
  this.docError = '';
}

/** Both requirements met? Drives the dialog's Approve button. */
get approveReady(): boolean {
  const r = this.approveFor;
  return !!r && this.regHasDoc(r) && !!r.schoolZone && String(r.schoolZone).trim() !== '';
}

/**
 * What is still missing, for the line above the button.
 *
 * Choosing a file is not sending it. The message used to read "Upload the
 * signed undertaking" in both cases, so once a PDF was picked the screen
 * showed the file, an enabled Upload button and a line still asking for the
 * thing that looked done - with no hint that Upload had not been pressed.
 */
get approveBlockedReason(): string {
  const r = this.approveFor;
  if (!r) { return ''; }
  if (this.uploadingDoc) { return 'Sending the undertaking...'; }
  if (!this.regHasDoc(r) && !this.approveDocStaged) {
    return 'Attach the signed undertaking to continue.';
  }
  if (!r.schoolZone || String(r.schoolZone).trim() === '') { return 'Choose a school zone to continue.'; }
  return '';
}

/** A PDF is chosen and waiting to be sent. */
get approveDocStaged(): boolean {
  const r = this.approveFor;
  return !!r && !this.regHasDoc(r) && this.selectedDocFor === r.schoolId && !!this.selectedDoc;
}

/** Enabled once the zone is set and the undertaking is either on file or chosen. */
get approveCanSubmit(): boolean {
  const r = this.approveFor;
  if (!r || this.uploadingDoc) { return false; }
  const zoneOk = !!r.schoolZone && String(r.schoolZone).trim() !== '';
  return zoneOk && (this.regHasDoc(r) || this.approveDocStaged);
}

get approveSubmitLabel(): string {
  if (this.uploadingDoc) { return 'Uploading...'; }
  return this.approveDocStaged ? 'Upload undertaking and approve' : 'Approve school';
}

/**
 * The whole decision behind one button.
 *
 * Attaching the undertaking and approving were two separate presses, and the
 * first was easy to miss - the file sat there chosen while Approve stayed
 * disabled. With a PDF staged this sends it first and approves once it lands.
 */
submitApprove() {
  const r = this.approveFor;
  if (!r || !this.approveCanSubmit) { return; }
  if (this.approveDocStaged) {
    this.uploadRegistrationDoc(r, null, () => this.finishApprove());
    return;
  }
  this.finishApprove();
}

private finishApprove() {
  const r = this.approveFor;
  if (!r) { return; }
  this.changeApprovedStatus(r.schoolId, r.approve);
  this.closeApprove();
}

/** Which copy button is showing its tick - '<schoolId>:<field>'. */
copiedKey = '';

/** Copy to clipboard for the id / email / phone icons. */
copyToClipboard(value: string | number, key: string) {
  // `any` on purpose: school.id is a number, email/mobile are strings.
  const text = (value === null || value === undefined ? '' : String(value)).trim();
  if (!text) { return; }
  // A tick on the button says it landed, without a toast covering the page.
  const done = () => {
    this.copiedKey = key;
    setTimeout(() => { if (this.copiedKey === key) { this.copiedKey = ''; } }, 1500);
  };
  const nav: any = navigator as any;
  if (nav && nav.clipboard && nav.clipboard.writeText) {
    nav.clipboard.writeText(text).then(done, () => this.fallbackCopy(text, done));
  } else {
    this.fallbackCopy(text, done);
  }
}

/** navigator.clipboard needs a secure context; plain http admin hosts have none. */
private fallbackCopy(text: string, done: () => void) {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  try { document.execCommand('copy'); done(); } catch { /* clipboard unavailable */ }
  document.body.removeChild(el);
}

/**
 * "IsAffilated: true" said nothing a reader could act on - neither what being
 * affiliated means nor, with a raw boolean, which way round it was.
 */
affiliationLabel(school: any): string {
  return this.yesNo(school && school.isAffiliate) === 'Yes' ? 'Affiliated' : 'Not affiliated';
}

volunteerLabel(school: any): string {
  return this.yesNo(school && school.isVoulnteer) === 'Yes' ? 'Volunteer school' : 'Not a volunteer school';
}

openMirrorMode() {
  if (!this.editingSchoolId) { return; }
  this.startingMirror = true;
  // Opened BEFORE the request returns: a tab opened later, from inside a
  // callback, is treated as a popup and blocked by the browser.
  const tab = window.open('', '_blank');
  this.schoolService.startMirrorMode(this.editingSchoolId).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.startingMirror = false;
      // The SERVER says where the portal is: this bundle is deployed to several
      // environments, and a compiled-in host sent staging admins to production.
      const base = (res && res.mirrorUrl) || (environment.portalUrl + '/school/mirror');
      const url = base + '?ticket=' + encodeURIComponent(res.ticket);
      if (tab) { tab.location.href = url; } else { window.open(url, '_blank'); }
    },
    (err: any) => {
      this.startingMirror = false;
      if (tab) { tab.close(); }
      this.messageService.add({
        key: 'custom', severity: 'error', summary: 'Mirror Mode',
        detail: (err && err.error && err.error.error) || 'Could not open Mirror Mode for this school.',
      });
    },
  );
}

editSchool(event: Event, car: any) {
  this.carId = car.id;
  this.carDatavalue = car;
  this.editingSchoolId = car.id;
  this.editingSchoolName = car.name;
  this.schoolEdit = true;
  this.subViewTitle = 'Edit School';
  // Bound with [(ngModel)] as well as formControlName, so both need setting.
  this.editingSavedEmail = (car.email || '').trim().toLowerCase();
  this.schoolType   = this.yesNo(car.isAffiliate !== undefined ? car.isAffiliate : car.isAffilated);
  this.volunteerData = this.yesNo(car.isVolunteer !== undefined ? car.isVolunteer : car.isVoulnteer);
  this.approvedData  = this.yesNo(car.isApproved);
  this.zoneData = car.schoolZone || car.zone || '';
  // The dialog used to open blank, so saving wiped whatever was not retyped.
  this.schoolForm.patchValue({
    schoolId:        car.id,
    schoolname:      car.name || car.school_name || '',
    schoolEmail:     car.email || '',
    schoolBoard:     car.board || '',
    schoolPassword:  '',
    schoolInfra:     car.schoolInfrastructure || car.infrastructure || '',
    schoolTelePhone: car.mobile || '',
    author1:         car.authorise1 || '',
    designation1:    car.designation1 || '',
    author2:         car.authorise2 || '',
    designation2:    car.designation2 || '',
    isAffilated:     this.yesNo(car.isAffiliate !== undefined ? car.isAffiliate : car.isAffilated),
    isApproved:      this.yesNo(car.isApproved),
    isVoulnteer:     this.yesNo(car.isVolunteer !== undefined ? car.isVolunteer : car.isVoulnteer),
    zone:            car.schoolZone || car.zone || '',
    schoolAddress:   car.address || '',
    gameCoach:       car.gameCoach || '',
  });
  this.display = true;
  event.preventDefault();
}

/** Mails the school a one-time link to set a new password. */
/** True while the Email box differs from what is stored. */
get emailUnsaved(): boolean {
  const typed = String((this.schoolForm.get('schoolEmail') || { value: '' }).value || '').trim().toLowerCase();
  return !!this.editingSchoolId && typed !== this.editingSavedEmail;
}

sendPasswordResetLink() {
  if (!this.editingSchoolId) { return; }

  // The link goes to the stored address, so an unsaved edit would send it to the
  // old one - and the admin would have no way of knowing.
  if (this.emailUnsaved) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Save the updated school details first',
      detail: 'Then send the link.',
    });
    return;
  }

  this.sendingResetLink = true;
  this.schoolService.sendPasswordResetLink(this.editingSchoolId).pipe(takeUntil(this.destroy$)).subscribe(
    (res: any) => {
      this.sendingResetLink = false;
      this.messageService.add({ key: 'custom', severity: 'success', life: 8000,
        summary: 'Reset link sent to ' + (res.email || 'the school'),
        detail: "If they don't see it, ask them to check spam and mark it \"Not spam\"." });
    },
    (err: any) => {
      this.sendingResetLink = false;
      this.messageService.add({ severity: 'error', summary: 'Could not send',
        detail: (err && err.error && err.error.error) || 'Try again' });
    },
  );
}

openResetPassword() {
  if (!this.editingSchoolId) { return; }
  this.resetPwNew = '';
  this.resetPwConfirm = '';
  this.resetPwError = '';
  this.resetPwShow = false;
  this.resetPwOpen = true;
}

closeResetPassword() {
  this.resetPwOpen = false;
  // Never leave a typed password sitting in memory behind a closed modal.
  this.resetPwNew = '';
  this.resetPwConfirm = '';
  this.resetPwError = '';
}

/** Mirrors the server's rules so the mismatch is caught before the round trip. */
get resetPwValid(): boolean {
  return this.resetPwNew.length >= 8 && this.resetPwNew === this.resetPwConfirm;
}

submitResetPassword() {
  this.resetPwError = '';
  if (this.resetPwNew.length < 8) {
    this.resetPwError = 'Password must be at least 8 characters.';
    return;
  }
  if (this.resetPwNew !== this.resetPwConfirm) {
    this.resetPwError = 'The two passwords do not match.';
    return;
  }

  this.resetPwBusy = true;
  this.schoolService
    .resetSchoolPassword(this.editingSchoolId, this.resetPwNew, this.resetPwConfirm)
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (res: any) => {
        this.resetPwBusy = false;
        this.closeResetPassword();
        this.messageService.add({
          key: 'custom', severity: 'success',
          summary: 'Password changed for ' + (res.email || 'this school'),
        });
      },
      (err: any) => {
        this.resetPwBusy = false;
        this.resetPwError = (err && err.error && err.error.error) || 'Could not change the password.';
      },
    );
}

onDialogHide() {
  this.selectedSchool = null;
}
/**
 * Open a school's signed undertaking. The file sits behind the upload gate, so
 * it is fetched with the bearer token and shown from an object URL rather than
 * linked directly.
 */
/**
 * The signed undertaking for the school being edited.
 *
 * Not the blank ISSO form - that is the template a school is sent, which is of
 * no use when the question is what THIS school actually signed and returned.
 */
openSchoolUndertaking(schoolId: number | string) {
  if (!schoolId) { return; }
  // Opened on the click, like the registration copy: a tab opened later from
  // inside the subscribe is treated as a pop-up and blocked.
  const tab = window.open('', '_blank');
  this.adminFeatures.schoolUndertaking(schoolId).subscribe(
    (blob: Blob) => {
      const url = URL.createObjectURL(blob);
      if (tab) { tab.location.href = url; } else { window.open(url, '_blank'); }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    },
    (err: any) => {
      if (tab) { tab.close(); }
      this.messageService.add({
        key: 'custom', severity: 'warn', summary: 'Signed undertaking', life: 8000,
        detail: (err && err.status === 404)
          ? 'This school has no signed undertaking on file.'
          : 'Could not open the signed undertaking.',
      });
    },
  );
}

openRegistrationDocument(registrationId: number | string) {
  if (!registrationId) return;
  /*
   * The tab is opened NOW, on the click, and pointed at the blob once it
   * arrives. window.open() called later from inside the subscribe is outside
   * the user gesture, so the browser treats it as a pop-up and blocks it -
   * which is why the link appeared to do nothing. Mirror Mode already opens
   * its tab up front for the same reason.
   */
  const tab = window.open('', '_blank');
  this.adminFeatures.registrationDocument(registrationId).subscribe(
    (blob: Blob) => {
      const url = URL.createObjectURL(blob);
      if (tab) { tab.location.href = url; } else { window.open(url, '_blank'); }
      // Revoked late: the new tab has to finish reading it first.
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    },
    () => {
      if (tab) { tab.close(); }
      this.messageService.add({ key: 'custom', severity: 'error', summary: 'Could not open the document' });
    },
  );
}

changeApprovedStatus(schoolId,approvedStatus) {
  //console.log(eventData)
  // const eventStatus =  eventData.event_status
  // const eventId = eventData.eventId
  const formData = new FormData();
  if(approvedStatus == '1') {
    formData.append('approve', '0');
  } else {
    formData.append('approve', '1');
  }

  // Both branches used to claim success, and the error callback said nothing at
  // all - a refused approval looked identical to an approved school.
  this.schoolService.changeApprovedStatus(schoolId, formData).pipe(takeUntil(this.destroy$)).subscribe(
    res => {
      const approving = approvedStatus != '1';
      this.messageService.add({
        key: 'custom', severity: 'success',
        summary: approving ? 'Approved Successfully' : 'Approval removed',
      });
      this.display = false;
      this.registeredSchool();
    },
    error => {
      this.error = error;
      const msg = (error && error.error && (error.error.error || error.error.message))
        || 'Could not approve this school. Try again.';
      this.messageService.add({ key: 'custom', severity: 'error', summary: 'Not approved', detail: msg, life: 8000 });
      this.registeredSchool();
    }
  );

}
onSortChange(event) {
  let value = event.value;
  if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
  }
  else {
      this.sortOrder = 1;
      this.sortField = value;
  }
}
 
getSchoolData() {
      this.registeredSchoolFlag =  false;
      this.totalNonAffilatedSchoool = 0;
      this.schoolService.getSchoolList(this.selectedZoneVal, this.approvalFilter).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if(response!=="") {
          this.schoolServiceData =response;
          this.schoolData = this.schoolServiceData;
          // Re-apply the search: changing the zone refetches, and without this
          // the list silently widened back out to every school.
          this.applyTabSearch(this.tabSearch);
          this.totalSchoolCount = (this.schoolServiceData || []).length;
          if(this.schoolData) {
            this.totalNonAffilatedSchoool = this.schoolData.filter((d => d.isAffiliate=='No')).length;
          }
        } else {
        }

     } ,
     error => {
       //this.errorAlert =true;
      });

}

/** Re-reads the tab under the chosen approval filter. */
showDialog(rowid:number) {
  this.display = true;
}

initialForm() {
  this.options = [
    {label: "Please select", value: ''},
    {label: "Yes", value: 'Yes'},
    {label: "No", value: 'No'},
  ];
  this.zoneOptions =this.issoUtilService.setSchoolZone();
  /* The form's list starts with "Please select" and an empty value, which as a
     filter means neither "all" nor a zone. The filter gets its own. */
  this.zoneFilterOptions = [
    { label: 'All zones', value: 'noZone' },
    ...this.issoUtilService.setSchoolZone().filter((z: any) => !!z.value),
  ];
  this.zoneData = 'noZone';
 

    this.schoolForm = this.fb.group({
      schoolId:[''],
      schoolname: ['', Validators.required],
      schoolEmail: ['', Validators.required],
      schoolBoard: ['', Validators.required],
      schoolPassword: [''],
      schoolInfra: ['', Validators.required],
      schoolTelePhone: ['', Validators.required],
      author1: ['', Validators.required],
      designation1: ['', [Validators.required, Validators.pattern('^[0-9]+$'),Validators.min(1000000000), Validators.max(999999999999)]],
      author2: ['', Validators.required],
      designation2: ['', [Validators.required, Validators.pattern('^[0-9]+$'),Validators.min(1000000000), Validators.max(999999999999)]],
      isAffilated: ['', Validators.required],
      isApproved: ['Yes'],
      isVoulnteer: ['', Validators.required],
      // Switch on means the school shows on the public website. Stored the
      // other way round in the legacy flag: '0' visible, '1' hidden.
      isWebVisible: [true],
      zone: ['', Validators.required],
      schoolAddress: ['', Validators.required],
      gameCoach: ['', Validators.required],
     
    });
}
updateZone(schoolId,event) { 
 const zoneVal = event.value;
 if(zoneVal != '') {
  this.schoolService.saveSchoolZone(schoolId,zoneVal).pipe(takeUntil(this.destroy$)).subscribe(
  res => {
      if (res.status === 'error') {
        this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
      } else {
        this.messageService.add({key: 'custom', severity:'success', summary: 'Zone Updated Successfully'});

      }
      this.display =false
      this.registeredSchool();
  },
  error => this.error = error
);

} 
}
get f() { return this.schoolForm.controls; }
addNewSchool(event: Event, schoolData: School,type:any) {
  this.showValidationSummary = false;
  this.editingSchoolId = 0;
  this.editingSchoolName = '';
  // Cleared for 'add' - otherwise Delete in the form would still point at the
  // last school opened. Only editSchool() used to set it, so arriving here from
  // a card left it stale or undefined.
  this.carDatavalue = null;
  this.schoolForm.reset({ schoolId: '' });
    if(type == 'edit') {
        const row: any = schoolData;
        this.schoolEdit = true;
        this.carDatavalue = row;
        this.editingSchoolId = row.id;
        this.editingSchoolName = row.name || '';
        this.schoolType = this.yesNo(row.isAffiliate !== undefined ? row.isAffiliate : row.isAffilated);
        this.volunteerData = this.yesNo(row.isVolunteer !== undefined ? row.isVolunteer : row.isVoulnteer);
        this.approvedData  = this.yesNo(row.isApproved);
        this.zoneData = row.schoolZone;
        this.emailOfSchool = row.email || '';
        this.editingSavedEmail = (row.email || '').trim().toLowerCase();
        this.setPassword = '';

        this.schoolForm.setValue({
            schoolId:        row.id,
            schoolname:      row.name || '',
            schoolEmail:     row.email || '',
            schoolBoard:     row.board || '',
            schoolPassword:  '',
            schoolInfra:     row.schoolInfrastructure || '',
            schoolAddress:   row.address || '',
            schoolTelePhone: row.mobile || '',
            isAffilated:     this.yesNo(row.isAffiliate !== undefined ? row.isAffiliate : row.isAffilated),
            isApproved:      this.yesNo(row.isApproved),
            isVoulnteer:     this.yesNo(row.isVolunteer !== undefined ? row.isVolunteer : row.isVoulnteer),
            isWebVisible:    row.isWebVisible !== '1',
            zone:            row.schoolZone || row.zone || '',
            // The API sends authorise1/2; the form controls kept the old names.
            author1:         row.authorise1 || '',
            designation1:    row.designation1 || '',
            author2:         row.authorise2 || '',
            designation2:    row.designation2 || '',
            gameCoach:       row.gameCoach || '',
        });
         this.subViewTitle = 'Edit School';
   } else {
          this.schoolEdit = false;
          this.emailOfSchool = '';
          this.setPassword = '';
          this.schoolForm.setValue({ 
            schoolId:'',   
            schoolname: '',
            schoolEmail: '',
            schoolBoard: ' ',
            schoolPassword: ' ',
            schoolInfra: ' ',
            schoolAddress: ' ',
            schoolTelePhone:' ',
            author1:' ',
            designation1:' ',
            author2:' ',
            designation2:' ',
            isAffilated:'',
            isApproved:'Yes',
            isVoulnteer:'',
            isWebVisible: true,
            zone:'',
            gameCoach:''
          //  schoolId:'add'  
          }); 
          this.subViewTitle = 'Add New School';
    }
    this.display = true;
    
    
}

hideExtraView() {
  this.display = false;
}
setSchoolPassword(){
  if(!this.schoolEdit) {
    let password;
    let schoolName = this.schoolForm.get('schoolname').value;
    schoolName = schoolName.trim();
    password = schoolName.replace(/\s/g, "");
    this.setPassword = password.substring(0, 5) + '12345';
  }
}
checkEmail(email) {
  this.emailOfSchool =  email.target.value;
  this.schoolService.verifyEmail(this.emailOfSchool).pipe(takeUntil(this.destroy$)).subscribe((data) => {
   
    this.verifyEmailForSchool = data;
    if (this.verifyEmailForSchool.length > 0) {
      //this.schoolId = data[0].schoolId;
      this.emailOfSchool = '';
      this.showEmailErrorMessage = true;
    } else {
      this.showEmailErrorMessage = false;
    }
   },
    error => this.error = error
  );
}

// Form controls carry the old internal names; these are what the labels say.
private static readonly FIELD_LABELS = {
  schoolname:      'School Name',
  schoolEmail:     'Email',
  schoolBoard:     'School Board',
  schoolInfra:     'Infrastructure at school',
  schoolAddress:   'School Address',
  schoolTelePhone: 'Contact Number',
  author1:         'Concerned Person and Designation (1)',
  designation1:    'Contact No. (1)',
  author2:         'Concerned Person and Designation (2)',
  designation2:    'Contact No. (2)',
  isAffilated:     'Affilated',
  isApproved:      'Approved',
  isVoulnteer:     'Volunteer',
  zone:            'Zone',
  gameCoach:       'No. of coaches and their specialised games',
};

showValidationSummary = false;

// Every control blocking the save, with the reason spelled out. Legacy rows
// often fail the phone-number rules on fields that were free text for years,
// which used to leave Submit dead with nothing on screen explaining it.
get invalidFields(): { label: string, reason: string }[] {
  if (!this.schoolForm) return [];
  const out = [];
  Object.keys(this.schoolForm.controls).forEach(name => {
    const control = this.schoolForm.get(name);
    if (!control || control.valid) return;
    const e = control.errors || {};
    let reason = 'is not valid';
    if (e.required)          reason = 'is required';
    else if (e.pattern)      reason = 'must contain digits only';
    else if (e.min || e.max) reason = 'must be a 10-digit number';
    out.push({ label: AdminSchoolComponent.FIELD_LABELS[name] || name, reason });
  });
  return out;
}

onSubmit() {
      this.submitted = true;

      // Say why nothing saved rather than leaving the admin to guess.
      if (this.schoolForm.invalid) {
        Object.keys(this.schoolForm.controls)
          .forEach(name => this.schoolForm.get(name).markAsTouched());
        this.showValidationSummary = true;
        this.messageService.add({key: 'custom', severity: 'error',
          summary: 'Cannot save - ' + this.invalidFields.length + ' field(s) need fixing'});
        return;
      }
      this.showValidationSummary = false;

      const formData = new FormData();
      let schoolID =  this.schoolForm.get('schoolId').value;
      formData.append('schoolname', this.schoolForm.get('schoolname').value);
      formData.append('schoolEmail', this.schoolForm.get('schoolEmail').value);
      formData.append('schoolBoard', this.schoolForm.get('schoolBoard').value);
      formData.append('schoolPassword', this.schoolForm.get('schoolPassword').value);
      formData.append('schoolInfra', this.schoolForm.get('schoolInfra').value);
      formData.append('schoolTelePhone', this.schoolForm.get('schoolTelePhone').value);
      formData.append('author1', this.schoolForm.get('author1').value);
      formData.append('designation1', this.schoolForm.get('designation1').value);
      formData.append('author2', this.schoolForm.get('author2').value);
      formData.append('designation2', this.schoolForm.get('designation2').value);
      formData.append('gameCoach', this.schoolForm.get('gameCoach').value);
      formData.append('isAffilated', this.schoolForm.get('isAffilated').value);
      formData.append('isApproved', this.schoolForm.get('isApproved').value);
      formData.append('isVoulnteer', this.schoolForm.get('isVoulnteer').value);
      formData.append('webStatus', this.schoolForm.get('isWebVisible').value ? '0' : '1');
      formData.append('zone', this.schoolForm.get('zone').value);
      formData.append('schoolAddress', this.schoolForm.get('schoolAddress').value);
    // formData.append('hiddentext', this.schoolForm.get('hiddentext').value);
     if(schoolID == '') {
        this.schoolService.saveSchoolData(formData).pipe(takeUntil(this.destroy$)).subscribe(
        res => {
            if (res.status === 'error') {
              this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
            } else {
              this.messageService.add({key: 'custom', severity:'success', summary: 'New School Added Successfully'});

            }
          this.displayDialog = false;
          this.display =false
          this.getSchoolData();
        },
        error => {
          this.error = error;
          // A refused add (duplicate email, bad email) used to show nothing at all.
          this.messageService.add({
            key: 'custom',
            severity: 'error',
            summary: (error && error.errorDesc) || 'Could not add the school',
          });
        }
      );

    } 
     else {
      this.schoolService.editSchoolData(schoolID,formData).pipe(takeUntil(this.destroy$)).subscribe(
        res => {
            if (res.status === 'success') {
              this.messageService.add({key: 'custom', severity:'success', summary: 'School Data Updated Successfully'});
              this.editingSavedEmail = String((this.schoolForm.get('schoolEmail') || { value: '' }).value || '').trim().toLowerCase();
           }
          else {
             this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});

            }
          // The edit dialog binds to displayDialog, not display - closing the
          // wrong flag left it open and made a successful save look like a no-op.
          this.displayDialog = false;
          this.display =false
          this.getSchoolData();
        },
        error => {
          this.error = error;
          this.messageService.add({
            key: 'custom',
            severity: 'error',
            summary: (error && error.errorDesc) || 'Could not update the school',
          });
        }
      );

     }
 
}
deleteRegisteredSchoolData(schoolId) {
  if (event.defaultPrevented) return;
  event.preventDefault();
  this.confirmation.confirm({
    key: 'confirm-delete-school',
    icon: 'pi pi-info-circle',
    message: 'Delete this application? The school record and its login are not removed.',
    accept: () => { this.deleteRegisteredSchool(schoolId); },
  });
}

deleteSchoolData(event: Event, schoolData: School) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: 'confirm-delete-school',
      icon: 'pi pi-info-circle',
      message: 'Are you sure to delete school data?',
      accept: () => { this.deleteSchool(schoolData); },
    });
}

private _deleteSchoolData() {
    this.messageService.add({key: 'custom', severity:'success', summary: 'School Data Deleted Successfully'});
}

deleteSchool(School) {
  let schoolId=School.id
  this.schoolService.deleteSchool(schoolId).pipe(takeUntil(this.destroy$)).subscribe(
   res => {
     //  if (res.status !== 'error') {
     //    this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
     //  } else {
         this.messageService.add({key: 'custom', severity:'success', summary: 'School Data Deleted Successfully'});

     //  }

     this.display =false
     this.getSchoolData();
   },
   error => this.error = error
 );
}
deleteRegisteredSchool(schoolId) {
 
  this.schoolService.deleteRegisteredSchool(schoolId).pipe(takeUntil(this.destroy$)).subscribe(
   (res: any) => {
     // The server says what it actually removed - whether the school record and
     // its login went too, or were kept because they hold real data.
     this.messageService.add({
       key: 'custom', severity: 'success', life: 8000,
       summary: 'Application deleted',
       detail: 'The application has been removed.',
     });
     this.display = false;
     // Reload the REGISTRATIONS list - this action belongs to that tab, and
     // reloading the Schools tab left the deleted row on screen.
     this.registeredSchool();
   },
   (err: any) => {
     this.messageService.add({
       key: 'custom', severity: 'error', life: 8000, summary: 'Delete',
       detail: (err && err.error && err.error.message) || 'Could not delete this application.',
     });
   }
 );
}
/**
 * Download the school list as a spreadsheet.
 *
 * Named `importSchoolExcel` and labelled "Import in Excel" since the legacy app,
 * where it did exactly this too - there has never been an import on either
 * backend. Renamed so the button stops promising one.
 */
exportSchoolExcel() {
  const rows = this.registeredSchoolFlag ? this.showRegisterdSchoolData : this.schoolData;
  this.meritService.exportAsExcelFile(rows, this.registeredSchoolFlag ? 'school-registrations' : 'school-data');
}

private _dropDatabase() {
}


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
